import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchActiveSocialLinks = async () => {
  const res = await apiClient.get(`/social-links/active`);
  return res.data?.data || [];
};

export const fetchSocialLinks = async () => {
  const res = await apiClient.get(`/social-links/get_all`, getAuthHeader());
  return res.data?.data || [];
};

export const createSocialLink = async (payload) => {
  return apiClient.post(`/social-links/create`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const updateSocialLink = async (id, payload) => {
  return apiClient.post(`/social-links/update/${id}`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const deleteSocialLink = async (id) => {
  return apiClient.delete(`/social-links/delete/${id}`, getAuthHeader());
};
